var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('popup-slot',[_c('quiz-found-message'),_c('quiz-card'),_c('quiz-number'),_c('quiz-point-name'),_c('quiz-url'),_c('quiz-description'),_c('quiz-hints'),_c('button-to-Answer'),_c('button-close')],1)}
var staticRenderFns = []

export { render, staticRenderFns }